import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/diagram-lifecycle-of-an-emotion.png';

export const TheLifecycleOfAnEmotionStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>{t('week-3.the-lifecycle-of-an-emotion.title')}</S.StepHeading>
                <S.StepDescription small>
                    {t('week-3.the-lifecycle-of-an-emotion.description')}
                </S.StepDescription>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepImg src={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
));
